




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import PlanItem from './PlanItem.vue';
import { UserTreatment } from '@/models/user-treatment';
import ApiHelper from '@/api/ApiHelper';
import Toast from '@common/helpers/toast';
import PageLoader from '@components/common/PageLoader.vue';

@Component({
  components: { PlanItem, PageLoader },
})
export default class PlanListSuggestPopup extends Vue {
  @Prop({ required: true }) readonly name!: string;

  @State((state) => state.treatment_detail.data)
  activeTreatment!: UserTreatment;

  plans: any[] = [];
  isLoading = false;

  get treatmentId(): number | null {
    return this.activeTreatment?.id ?? null;
  }

  async getLastFeedbackPlans() {
    if (!this.treatmentId) {
      return;
    }

    this.isLoading = true;
    try {
      const res = await ApiHelper.getApi(
        'DoctorFeedbackApi',
      ).getByUserTreatment(this.treatmentId, {
        with: 'plans:id,name,status,karte_status;plans.medicines:id,name,usage',
      });

      const feedback = res.data?.data || res.data;
      this.plans =
        feedback?.plans.map((plan) => ({
          ...plan,
          recommended: plan.pivot.recommended,
        })) || [];
    } catch (error) {
      Toast.error(
        (error as any).response?.data?.message ||
          'プランの取得に失敗しました。',
      );
    } finally {
      this.isLoading = false;
    }
  }

  closeModal() {
    this.$modal.hide(this.name);
  }
}
